function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "main"
}, /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 60.667,
  y1: 131.75,
  x2: 724.446,
  y2: 131.75
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 71.795,
  y1: 161.25,
  x2: 724.446,
  y2: 161.25
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 71.5,
  y1: 165.5,
  x2: 723.672,
  y2: 165.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 71.795,
  y1: 191.75,
  x2: 724.446,
  y2: 191.75
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 71.795,
  y1: 196,
  x2: 724.446,
  y2: 196
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 121.667,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 121.667,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 171.834,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 171.834,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 71.5,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 222.001,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 222.001,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 272.168,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 272.168,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 322.335,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 322.335,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 372.502,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 372.502,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 422.669,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 422.67,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 472.836,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 472.837,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 523.003,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 523.004,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 573.17,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 573.171,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 623.337,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 623.338,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 673.504,
  cy: 179.16,
  r: 7.167
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 673.505,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 723.672,
  cy: 179.16,
  r: 2.791
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st11 Q7moving",
  x1: 57.833,
  y1: 147.625,
  x2: 741.755,
  y2: 147.625
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M731,147.625"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "572.623,85.488 552.42,80.643 553.29,70.078 564.49,62.08 574.818,64.646  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "572.623,85.488 559.469,75.48 558.94,65.971 567.701,69.709  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 559.469,
  y1: 75.48,
  x2: 553.29,
  y2: 70.078
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 567.701,
  y1: 69.709,
  x2: 564.49,
  y2: 62.08
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 552.42,
  y1: 80.643,
  x2: 574.956,
  y2: 64.843
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M53.063,163.111c-3.039-4.063-4.645-8.899-4.645-13.986c0-12.889,10.487-23.375,23.376-23.375 c4.923,0,9.856,1.639,13.843,4.5l-1.999,2.35c0,0-3.344,0.176-4.53-0.34c-2.289-0.994-4.765-1.51-7.314-1.51 c-10.133,0-18.376,8.242-18.376,18.375c0,2.42,0.463,4.769,1.357,6.953c0.323,0.79,1.138,4.902,1.138,4.902L53.063,163.111z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M72.788,144.431"
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 71.795,
  y1: 122.5,
  x2: 724.446,
  y2: 122.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 71.795,
  cy: 178.625,
  r: 13.126
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M54.415,169.296c-5.662-4.882-9.246-12.108-9.246-20.171c0-14.705,11.92-26.625,26.626-26.625"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st15",
  cx: 71.5,
  cy: 178.625,
  r: 5.16
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M71.795,196c-9.597,0-17.376-7.778-17.376-17.375s7.779-17.375,17.376-17.375"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M71.795,131.792c-9.597,0-17.376,7.778-17.376,17.375v29.458"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M743.178,163.111c3.039-4.063,4.646-8.899,4.646-13.986c0-12.889-10.487-23.375-23.377-23.375 c-4.924,0-9.856,1.639-13.844,4.5l2,2.35c0,0,3.344,0.176,4.529-0.34c2.289-0.994,4.765-1.51,7.314-1.51 c10.133,0,18.377,8.242,18.377,18.375c0,2.42-0.463,4.769-1.357,6.953c-0.323,0.79-1.139,4.902-1.139,4.902L743.178,163.111z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 724.446,
  cy: 178.625,
  r: 13.126
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M741.827,169.296c5.662-4.882,9.246-12.108,9.246-20.171c0-14.705-11.921-26.625-26.627-26.625"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st15",
  cx: 724.741,
  cy: 178.625,
  r: 5.16
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M724.446,196c9.598,0,17.377-7.778,17.377-17.375s-7.779-17.375-17.377-17.375"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M724.446,131.792c9.598,0,17.377,7.778,17.377,17.375v29.458"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_tube"
}, /*#__PURE__*/React.createElement("rect", {
  x: 176.7,
  y: 69,
  className: "st91",
  width: 91.1,
  height: 27.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st91",
  points: "257.7,59.6 261.2,71.6 261.2,90.4 183.2,90.4 183.2,71.6 186.6,59.6  "
})), /*#__PURE__*/React.createElement("rect", {
  x: 186.6,
  y: 59.6,
  className: "st91",
  width: 71.1,
  height: 18.7
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_tube"
}, /*#__PURE__*/React.createElement("rect", {
  x: 478.7,
  y: 69,
  className: "st94",
  width: 91.1,
  height: 27.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st94",
  points: "559.8,59.6 563.2,71.6 563.2,90.4 485.2,90.4 485.2,71.6 488.7,59.6  "
})), /*#__PURE__*/React.createElement("rect", {
  x: 488.7,
  y: 59.6,
  className: "st94",
  width: 71.1,
  height: 18.7
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_hand"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M251.024,86.459c-0.792,0-1.58-0.328-2.145-0.969l-11.753-13.363c-1.015-1.152-0.934-2.9,0.18-3.957 l23.118-21.905c1.143-1.084,2.95-1.036,4.035,0.108c1.084,1.145,1.035,2.951-0.108,4.036l-21.122,20.013l9.937,11.298 c1.041,1.184,0.925,2.987-0.258,4.028C252.365,86.225,251.693,86.459,251.024,86.459z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M273.952,86.459c0.792,0,1.58-0.328,2.145-0.969l11.753-13.363c1.015-1.152,0.935-2.9-0.18-3.957 l-23.118-21.905c-1.143-1.084-2.949-1.036-4.034,0.108s-1.036,2.951,0.108,4.036l21.122,20.013L271.81,81.72 c-1.041,1.184-0.925,2.987,0.258,4.028C272.611,86.225,273.284,86.459,273.952,86.459z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 259.734,
  y: -70,
  className: "st0",
  width: 5.508,
  height: 106
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M272.109,50.234c0,5.314-4.308,9.622-9.621,9.622l0,0c-5.313,0-9.621-4.308-9.621-9.622v-9.363 c0-5.314,4.308-9.622,9.621-9.622l0,0c5.313,0,9.621,4.308,9.621,9.622V50.234z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 262.488,
  cy: 50.833,
  r: 3.334
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_hand"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M553.026,86.459c-0.792,0-1.58-0.328-2.146-0.969l-11.753-13.363c-1.015-1.152-0.934-2.9,0.18-3.957 l23.118-21.905c1.144-1.084,2.95-1.036,4.035,0.108c1.084,1.145,1.035,2.951-0.108,4.036l-21.121,20.013l9.937,11.298 c1.041,1.184,0.925,2.987-0.258,4.028C554.367,86.225,553.695,86.459,553.026,86.459z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M575.954,86.459c0.792,0,1.58-0.328,2.145-0.969l11.753-13.363c1.016-1.152,0.936-2.9-0.18-3.957 l-23.118-21.905c-1.143-1.084-2.948-1.036-4.033,0.108c-1.086,1.144-1.036,2.951,0.107,4.036l21.122,20.013l-9.938,11.298 c-1.041,1.184-0.925,2.987,0.259,4.028C574.613,86.225,575.286,86.459,575.954,86.459z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 561.736,
  y: -70,
  className: "st0",
  width: 5.508,
  height: 106
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M574.111,50.234c0,5.314-4.309,9.622-9.621,9.622l0,0c-5.313,0-9.621-4.308-9.621-9.622v-9.363 c0-5.314,4.308-9.622,9.621-9.622l0,0c5.313,0,9.621,4.308,9.621,9.622V50.234z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 564.49,
  cy: 50.833,
  r: 3.334
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_3"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_4"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_5"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_6"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_7"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st9",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_3"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_4"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_5"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_6"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_7"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 694.267,149.933 695.137,139.368 706.337,131.37 716.665,133.937  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "714.47,154.778 701.315,144.771 700.787,135.261 709.548,138.999  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 701.315,
  y1: 144.771,
  x2: 695.137,
  y2: 139.368
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 709.548,
  y1: 138.999,
  x2: 706.337,
  y2: 131.37
}), /*#__PURE__*/React.createElement("line", {
  className: "st17",
  x1: 694.267,
  y1: 149.933,
  x2: 716.803,
  y2: 134.132
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "R9_x5F_box_1_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 485.2,
  y: 89.3,
  className: "st90",
  width: 77.7,
  height: 7.1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st94",
  d: "M584.8,145.9h-121v-37.6c0-6.6,6.1-12,13.6-12h93.9c7.5,0,13.6,5.4,13.6,12V145.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 478.7,
  y: 96.3,
  className: "st94",
  width: 91.1,
  height: 31.9
}), /*#__PURE__*/React.createElement("path", {
  className: "st94",
  d: "M584.8,161.5h-121v-15c0-6.6,6.1-12,13.6-12h93.9c7.5,0,13.6,5.4,13.6,12V161.5z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st94",
  x1: 569.8,
  y1: 115.8,
  x2: 478.7,
  y2: 115.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st94",
  x1: 569.8,
  y1: 107.2,
  x2: 478.7,
  y2: 107.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 490,
  y: 102.8,
  className: "st94",
  width: 68.4,
  height: 17.3
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st94",
  cx: 480,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st94",
  cx: 502.1,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st94",
  cx: 524.2,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st94",
  cx: 546.4,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st94",
  cx: 568.5,
  cy: 151.4,
  r: 3.4
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st95",
  d: "M524.6,116.5h-2.2l-1.4-2.4c-0.3-0.5-0.5-0.8-0.7-0.9c-0.2-0.1-0.4-0.2-0.6-0.2H519v3.5h-1.9v-9.1h3.2 c2.2,0,3.2,0.8,3.2,2.5c0,0.6-0.2,1.1-0.5,1.6c-0.4,0.4-0.9,0.8-1.5,0.9v0c0.4,0.1,0.9,0.6,1.4,1.4L524.6,116.5z M519,108.9v2.6 h0.9c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.8-0.5-1.2-1.5-1.2L519,108.9L519,108.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st95",
  d: "M530.8,109.2c-0.5-0.3-1.1-0.5-1.7-0.5c-1.5,0-2.2,1-2.2,2.9l0,0c0.4-0.6,1-0.9,1.8-0.9 c0.8,0,1.4,0.3,1.9,0.8c0.5,0.5,0.7,1.2,0.7,2c0,0.9-0.3,1.7-0.9,2.3s-1.3,0.9-2.3,0.9c-1,0-1.8-0.4-2.3-1.1 c-0.6-0.7-0.8-1.8-0.8-3.1c0-1.6,0.3-2.8,1-3.8c0.7-0.9,1.6-1.4,2.9-1.4c0.7,0,1.3,0.1,1.9,0.3L530.8,109.2L530.8,109.2z  M529.4,113.6c0-0.5-0.1-0.9-0.3-1.1c-0.2-0.3-0.5-0.4-1-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.6-0.3,1 c0,0.5,0.1,0.9,0.3,1.2c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.7-0.1,0.9-0.4C529.3,114.4,529.4,114.1,529.4,113.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st94",
  points: "559.8,78.4 563.2,90.4 485.2,90.4 488.7,78.4  "
})), /*#__PURE__*/React.createElement("line", {
  className: "st94",
  x1: 573.7,
  y1: 134.5,
  x2: 573.7,
  y2: 96.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st94",
  x1: 475,
  y1: 134.5,
  x2: 475,
  y2: 96.4
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "R12_x5F_box"
}, /*#__PURE__*/React.createElement("rect", {
  x: 183.2,
  y: 89.3,
  className: "st90",
  width: 77.7,
  height: 7.1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st91",
  d: "M282.7,145.9h-121v-37.6c0-6.6,6.1-12,13.6-12h93.9c7.5,0,13.6,5.4,13.6,12V145.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 176.7,
  y: 96.3,
  className: "st91",
  width: 91.1,
  height: 31.9
}), /*#__PURE__*/React.createElement("path", {
  className: "st91",
  d: "M282.7,161.5h-121v-15c0-6.6,6.1-12,13.6-12h93.9c7.5,0,13.6,5.4,13.6,12V161.5z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st92",
  x1: 267.8,
  y1: 115.8,
  x2: 176.7,
  y2: 115.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st92",
  x1: 267.8,
  y1: 107.2,
  x2: 176.7,
  y2: 107.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 188,
  y: 102.8,
  className: "st91",
  width: 68.4,
  height: 17.3
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st93",
  d: "M219,116.9h-2.2l-1.4-2.4c-0.3-0.5-0.5-0.8-0.7-0.9c-0.2-0.1-0.4-0.2-0.6-0.2h-0.6v3.5h-1.9v-9.1h3.2 c2.2,0,3.2,0.8,3.2,2.5c0,0.6-0.2,1.1-0.5,1.6c-0.4,0.4-0.9,0.8-1.5,0.9v0c0.4,0.1,0.9,0.6,1.4,1.4L219,116.9z M213.5,109.3v2.6 h0.9c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.8-0.5-1.2-1.5-1.2L213.5,109.3L213.5,109.3L213.5,109.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st93",
  d: "M225.6,116.9h-5.7v-1.5h1.9v-5.8l-1.9,0.4v-1.6l3.8-0.8v7.7h1.9L225.6,116.9L225.6,116.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st93",
  d: "M232.9,116.9h-5.9v-1.5l2.6-2.5c0.5-0.5,0.9-1,1.1-1.3c0.2-0.4,0.3-0.7,0.3-1.1c0-0.9-0.5-1.3-1.4-1.3 c-0.8,0-1.5,0.3-2.3,0.9v-1.7c0.8-0.5,1.7-0.8,2.6-0.8c0.9,0,1.6,0.2,2.1,0.7s0.8,1.1,0.8,1.9c0,1.1-0.6,2.2-1.9,3.3l-1.9,1.7v0 h3.7L232.9,116.9L232.9,116.9L232.9,116.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st92",
  cx: 178,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st92",
  cx: 200.1,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st92",
  cx: 222.2,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st92",
  cx: 244.3,
  cy: 151.4,
  r: 3.4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st92",
  cx: 266.4,
  cy: 151.4,
  r: 3.4
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st91",
  points: "257.7,78.4 261.2,90.4 183.2,90.4 186.6,78.4  "
})), /*#__PURE__*/React.createElement("line", {
  className: "st92",
  x1: 271.7,
  y1: 134.5,
  x2: 271.7,
  y2: 96.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st92",
  x1: 172.9,
  y1: 134.5,
  x2: 172.9,
  y2: 96.4
}));

var SvgMhwQ7 = function SvgMhwQ7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q7svg",
    x: "0px",
    y: "0px",
    width: "714.5px",
    height: "202px",
    viewBox: "39.5 0 714.5 202",
    style: {
      enableBackground: "new 39.5 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMhwQ7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MHW_Q7.f155ebcb.svg";
export { ForwardRef as ReactComponent };